__turbopack_context__.v({
  "circle": "Switch-module-scss-module__Ht4ifa__circle",
  "off": "Switch-module-scss-module__Ht4ifa__off",
  "on": "Switch-module-scss-module__Ht4ifa__on",
  "switch": "Switch-module-scss-module__Ht4ifa__switch",
});
